import * as React from 'react';
import PropTypes from 'prop-types';

const ExpandButtonBottomIcon = ({ color = 'rgb(133, 137, 145)' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 10C18 10.3 17.9 10.5 17.7 10.7L12.7 15.7C12.3 16.1 11.7 16.1 11.3 15.7L6.3 10.7C5.9 10.3 5.9 9.7 6.3 9.3C6.7 8.9 7.3 8.9 7.7 9.3L12 13.6L16.3 9.3C16.7 8.9 17.3 8.9 17.7 9.3C17.9 9.5 18 9.7 18 10Z"
      fill={color}
    />
  </svg>
);
export default ExpandButtonBottomIcon;

ExpandButtonBottomIcon.propTypes = {
  color: PropTypes.string,
};
